export enum ServiceEventItemType { CASH = 1, CLAIM = 2 }

export class ServiceEventReassign {

    constructor(
    public Type: ServiceEventItemType,
    public ReferenceNumber: number) {}
}



// WEBPACK FOOTER //
// ./src/app/models/serviceEventReassign.model.ts